export const initialState = {
  searchStr: "",
  select: "Original",
  products: [],
};
